// src/lib/auth/useRole.js
import { useMemo } from 'react';
import { normalizeRole } from './roles';
import { useAuth } from '../auth'; // auth.jsx is in src/lib/auth.jsx, exported as default/context

export default function useRole() {
  const { profile, roleForAccess } = useAuth();
  return useMemo(() => normalizeRole(roleForAccess ?? profile?.type ?? null), [profile, roleForAccess]);
}
